/* Haptic feedback wrapper for the driver PWA.
   Uses the Web Vibration API (navigator.vibrate). Android Chrome supports it;
   iOS Safari silently returns false — that's the right behavior for a driver
   app shipped Android-first. All entry points wrap in try/catch so a denied
   permission or unsupported browser is a no-op, never an error. */

function vibrate(pattern: number | number[]): boolean {
  if (typeof navigator === 'undefined') return false;
  const nav = navigator as Navigator & { vibrate?: (pattern: number | number[]) => boolean };
  if (typeof nav.vibrate !== 'function') return false;
  try {
    return nav.vibrate(pattern);
  } catch {
    return false;
  }
}

export const haptic = {
  /** Micro-tap: 10ms — for everyday button/link/tile presses. */
  tap(): void { vibrate(10); },

  /** Selection: 20ms — for "I picked something" moments (language pill, menu wedge tap). */
  select(): void { vibrate(20); },

  /** Snap: ~5ms — for wheel detent crossings and rotational snap settle. */
  snap(): void { vibrate(5); },

  /** Success: 50ms — for committed lifecycle gates (slide-to-confirm fired, OTP auto-submit). */
  success(): void { vibrate(50); },

  /** Warning pattern: [40, 40, 40] — short-pause-short for validation errors, rejected actions. */
  warn(): void { vibrate([40, 40, 40]); },
};
